<style lang="less" scoped>
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.table {border-collapse: collapse;width: 100%;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;margin-bottom: 40px;}
.btnbox .elbtn {margin-top: 10px;margin-left: 15px;}
.recycling_box .delete {margin-left: 40px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.pagination{margin-bottom: 40px;}
/deep/.el-table-column--selection .cell{padding-right: 10px;}
/deep/.el-form-item__content .el-input {width: 400px;}
/deep/.el-form-item__label {width: 10%;margin-left: 100px;}
/deep/.el-form-item__content img {width: 148px;height: 148px;}
</style>

<template>
  <!--上传列表-->
  <div class="second" id="second">
    <div class="dmkclb—_box second">
      <el-table
        ref="multipleTable"
        :data="tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        stripe
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center'}">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="hyname" label="会议名称" width="400"></el-table-column>
        <el-table-column prop="hyzt" label="会议主题" width="200"> </el-table-column>
        <el-table-column label="拟办会时间" width="180">
          <template slot-scope='scope'>{{ scope.row.nhsj * 1000 | formatTime() }}</template>
        </el-table-column>
        <el-table-column prop="nhaad" label="拟办会地点" width="240"></el-table-column>
        <el-table-column prop="nhgm" label="拟办会规模" width="116"></el-table-column>
        <el-table-column prop="id" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="primary" @click="check(scope.row)">查看</el-button>
            <el-button type="danger" @click="deletefn(11, 60, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="btnbox">
        <el-button type="danger" class="elbtn delete" @click="deletesfn(11, 60)">批量删除</el-button>
      </div>
    </div>
    <!--底部分页-->
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="tableData.length">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import filters from '../method/filter'
import methods from '../method/methods'
export default {
  mixins: [filters, methods],
  data()
  {
    return {
      pageSize: 10,
      currentPage: 1,
      fileList_icon: [{url: ''}],
      fileList_img: [{url: ''}],
      form: {
        id: null,
        hyname: '',
        hyzt: '',
        nhsj: '',
        nhaad: '',
        nhgm: '',
        gsname: ''
      },
      //列表数据
      tableData: []
    }
  },
  created()
  {
    this.getList()
  },
  methods: {
    //获取数据
    getList()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 61,
        _exp: 'id > 0',
        orderby: 'id DESC'
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.tableData = []
        ret.forEach((item) =>
        {
          this.tableData.push({
            id: item.id,
            hyname: item.hyname,
            hyzt: item.hyzt,
            nhsj: item.nhsj,
            nhaad: item.nhaad,
            nhgm: item.nhgm
          })
        })
      })
    },
    // 点击查看
    check(row)
    {
      this.$router.push({path: '/BhbmShow', query: {id: row.id}})
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      window.public.deletefn(major, minor, row, that)
    },
    /**
     * 彻底删除——多
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletesfn(major, minor)
    {
      let that = this
      window.public.deletesfn(major, minor, that)
    },
    //————列表页的公共方法————
    //搜索
    search()
    {
      this.getList()
      this.handleSizeChange(this.form.count)
    },
    //重置搜索条件
    cancelfnBtn()
    {
      let str = 'count'
      let that = this
      window.public.cancelfnBtn(str, that)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/Bhbmgl.vue